// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202607300241/js/" + chunkId + "." + {"44":"2a43a4e3","225":"98d18323","481":"46007cfb","486":"0b742a2a","770":"8bec15af"}[chunkId] + ".0.7458157717569379.chunk.js";
};